import { useTheme } from "@mui/material";
import type { FC } from "react";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { BoxedSliderField } from "web_myplann/Inspiration/Components/BoxedSliderField";
import { InspirationAnchorList } from "web_myplann/Inspiration/Components/InspirationAnchorList";
import { InspirationSection } from "web_myplann/Inspiration/Components/InspirationSection";
import {
	RETIREMENT_INCOME_MIN,
	RETIREMENT_INCOME_STEP,
} from "web_myplann/Inspiration/Retirement/constants";
import { mapRetirementAnchor } from "web_myplann/Inspiration/Retirement/Mappers/mapRetirementAnchor";
import type { RetirementContext } from "web_myplann/Inspiration/Retirement/Types/RetirementTypes";

const R = Resources.Inspiration.Retirement;

type Props = {
	context: RetirementContext;
	onChangeIncome: (value: number) => void;
};

export const RetirementTargetSection: FC<Props> = ({
	context,
	onChangeIncome,
}) => {
	const { t } = useResource();
	const theme = useTheme();

	return (
		<InspirationSection title={t(R.targetTitle)} gap={theme.spacingTokens.md}>
			<InspirationAnchorList
				anchors={context.anchors.map(mapRetirementAnchor)}
				activeKey={context.activeAnchorKey}
				onSelect={onChangeIncome}
			/>

			<BoxedSliderField
				label={t(R.targetSliderLabel)}
				value={context.desiredIncome}
				onChange={onChangeIncome}
				min={RETIREMENT_INCOME_MIN}
				max={context.incomeMax}
				step={RETIREMENT_INCOME_STEP}
			/>
		</InspirationSection>
	);
};
